import { connect } from 'react-redux'
import { getFavoriteVehicles } from 'selectors/user'
import { removeVehicleFavorite, updateVehicleFavorite } from 'actions/user'
import FavoriteVehiclesDrawer from './FavoriteVehiclesDrawer'

const mapStateToProps = (state) => ({
  favoriteVehicles: getFavoriteVehicles(state),
})

const mapDispatchToProps = {
  removeVehicleFavorite,
  updateVehicleFavorite,
}

const FavoriteVehiclesDrawerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FavoriteVehiclesDrawer)

export default FavoriteVehiclesDrawerContainer
